module.exports = __webpack_public_path__ + "img/趋势预测2ico.b3353925.png";